import React, { useState } from "react";
import { useMutation } from "@apollo/client";
//import bcrypt from "bcryptjs";
import { ALL_MUNICONFIG, CREATE_MUNICONFIG } from "../queries";

import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
import kunnat from "kunnat";
//import {useTranslation} from "react-i18next"
/*
import {useTranslation} from "react-i18next"
const [t, i18n] = useTranslation("common")
{t("headers.agendas")}

*/
import ReCAPTCHA from "react-google-recaptcha";
/* eslint-disable react/prop-types */
const MuniconfigForm = ({ setError }) => {
  // eslint-disable-next-line;
  //const [t, i18n] = useTranslation("common");
  const [t] = useTranslation("common");
  const [name, setName] = useState("");
  const [votefilter, setVotefilter] = useState(false);
  const [strategyfilter, setStrategyfilter] = useState(false);
  const [initiativefilter, setInitiativefilter] = useState(false);
  const [active, setActive] = useState("");
  const [text, setText] = useState("");
  const [roles, setRoles] = useState("");
  const [strategytext, setStrategytext] = useState("");
  const [strategycomments, setStrategycomments] = useState(false);
  const [strategyswot, setStrategyswot] = useState(false);
  const [strategyfocusareas, setStrategyfocusareas] = useState(false);
  const [strategymap, setStrategymap] = useState(false);
  const [strategycommentcategories, setStrategycommentcategories] = useState("");
  const [strategyfocusareacategories, setStrategyfocusareacategories] = useState("");
  const [strategybudget, setStrategybudget] = useState(false);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  //console.log(token);
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  //console.log(setExecuting);
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }
  const [createMuniconfig] = useMutation(CREATE_MUNICONFIG, {
    refetchQueries: [{ query: ALL_MUNICONFIG }],
    // eslint-disable-next-line
    onError: (error) => {
      //setError(error.graphQLErrors[0].message);
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {;
      updateCacheWith(response.data.addComment);
    }*/
  });
  // eslint-disable-next-line;
  let userss = "";
  // eslint-disable-next-line
  userss = useParams().id;
  //console.log(userss);
  /*const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    setDatetime(pvm.toString());
    setName(event);
    //setUser(sectionss);
  };*/

  const submit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    const aika = Date.now();
    const pvm = new Date(aika);
    createMuniconfig({
      variables: {
        name: name,
        datetime: pvm.toString(),
        votefilter: votefilter,
        strategyfilter: strategyfilter,
        initiativefilter: initiativefilter,
        active: active,
        text: text,
        roles: roles,
        strategytext: strategytext,
        strategycomments: strategycomments,
        strategyswot: strategyswot,
        strategyfocusareas: strategyfocusareas,
        strategymap: strategymap,
        strategycommentcategories: strategycommentcategories,
        strategyfocusareacategories: strategyfocusareacategories,
        strategybudget: strategybudget,
      },
    });
    //sectionid: sectionid.length > 0 ? sectionid : "tyhjä";
    setName("");
    setVotefilter(false);
    setStrategyfilter(false);
    setInitiativefilter(false);
    setActive("");
    setText("");
    setRoles("");
    setStrategytext("");
    setStrategycomments(false);
    setStrategyswot(false);
    setStrategyfocusareas(false);
    setStrategymap(false);
    setStrategycommentcategories("");
    setStrategyfocusareacategories("");
    setStrategybudget(false);
    /**
     * 
     * 
     * datetime
    name
    votefilter
    strategyfilter
    initiativefilter
    active
    text
    strategytext
    strategycomments
    strategyswot
    strategyfocusareas
    strategymap
    strategycommentcategories
    strategyfocusareacategories
    strategybudget
      */
    //setSectionid(sectionss);
  };
  /*onst stylea = {
    background: "white",
    opacity: 0.9
  };*/
  //useEffect(() => {;
  // setSectionid(sectionss);
  //}, []);
  const getKunnat = (kunn) =>
    kunn.map((kunt) => {
      return (
        <MenuItem value={kunt.name} key={kunt.name}>
          {kunt.name}
        </MenuItem>
      );
    });
  if (submitted) {
    return (
      <div>
        <h2>Kuntien asetukset</h2>
        {t("common.formok")}
        <br />
      </div>
    );
  } else {
    return (
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="body1"
              color="dark"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>Kuntien asetukset - Lisää uusi</h2>
              <form onSubmit={submit}>
                name
                <FormControl fullWidth>
                  <InputLabel id="municipality">Kunta</InputLabel>
                  <Select
                    labelId="muni-select-label"
                    id="muni-select"
                    value={name}
                    label="Kunta"
                    onChange={(e) => setName(e.target.value)}
                    style={{ backgroundColor: "white" }}
                  >
                    {getKunnat(kunnat)}
                  </Select>
                </FormControl>
                <br />
                <br />
                votefilter
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={votefilter}
                  onChange={() => setVotefilter(!votefilter)}
                />
                <br />
                <br />
                strategyfilter
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategyfilter}
                  onChange={() => setStrategyfilter(!strategyfilter)}
                />
                <br />
                <br />
                initiativefilter
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={initiativefilter}
                  onChange={() => setInitiativefilter(!initiativefilter)}
                />
                <br />
                <br />
                active
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={active}
                  onChange={() => setActive(!active)}
                />
                <br />
                <br />
                text
                <TextField value={text} onChange={({ target }) => setText(target.value)} />
                <br />
                <br />
                roles
                <TextField value={roles} onChange={({ target }) => setRoles(target.value)} />
                <br />
                <br />
                strategytext
                <TextField
                  value={strategytext}
                  onChange={({ target }) => setStrategytext(target.value)}
                />
                <br />
                <br />
                strategycomments
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategycomments}
                  onChange={() => setStrategycomments(!strategycomments)}
                />
                <br />
                <br />
                strategyswot
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategyswot}
                  onChange={() => setStrategyswot(!strategyswot)}
                />
                <br />
                <br />
                strategyfocusareas
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategyfocusareas}
                  onChange={() => setStrategyfocusareas(!strategyfocusareas)}
                />
                <br />
                <br />
                strategymap
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategymap}
                  onChange={() => setStrategymap(!strategymap)}
                />
                <br />
                <br />
                strategycommentcategories
                <TextField
                  value={strategycommentcategories}
                  onChange={({ target }) => setStrategycommentcategories(target.value)}
                />
                <br />
                <br />
                strategyfocusareacategories
                <TextField
                  value={strategyfocusareacategories}
                  onChange={({ target }) => setStrategyfocusareacategories(target.value)}
                />
                <br />
                <br />
                strategybudget
                <Checkbox
                  style={{ backgroundColor: "grey" }}
                  sx={{
                    "&.Mui-checked": {
                      color: "red",
                    },
                  }}
                  value={strategybudget}
                  onChange={() => setStrategybudget(!strategybudget)}
                />
                <br />
                <br />
                <div>
                  <ReCAPTCHA
                    sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                    onChange={onChange}
                  />
                </div>
                <br />
                <br />
                <Button
                  style={{
                    backgroundColor: "#07575B",
                    color: "#C4DFE6",
                    fontSize: "14px",
                  }}
                  type="submit"
                  disabled={!verified}
                  executing={executing}
                  submitted={submitted}
                >
                  {submitted ? t("common.done") : executing ? "Verifying" : t("common.send")}
                </Button>
                <br />
                <br />
              </form>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    );
  }
};

export default MuniconfigForm;
